
























































































































































































  import {Component, Inject, Provide, ProvideReactive, Vue} from 'vue-property-decorator';
import draggable from "vuedraggable";
  import {ClioMatterApi} from "../../../repository/ClioMatterApi";
  import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
  import _ from '../../../../node_modules/lodash';
  Vue.use(DropDownListPlugin);
  import { SidebarPlugin } from '@syncfusion/ej2-vue-navigations';
  import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
  import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
  import {CreateKanbanEntry} from "@/repository/messagehub.dtos";
  import {KanbanApi} from "@/repository/KanbanApi";
  Vue.use(TextBoxPlugin);
  Vue.use(CheckBoxPlugin);
  Vue.use(SidebarPlugin);
  export default Vue.extend({
    name: "Todo",
    data () {
      let matterSearchData = [
        {displayNumber: "None", id:0}
      ];
      return{
        matterDataSource : matterSearchData,
        matterFields : { text: "displayNumber", value: "id" },
        target: '.content',
        kanbanList: [],
        kanbanCategories: ["Waiting", "To Do", "In Progress", "Done"],
        waitingList: [],
        toDoList: [],
        inProgressList: [],
        doneList: [],
        waiting: [],
        toDo: [],
        inProgress: [],
        onHold:[],
        selectedMatter : null,
        allowFiltering: true,
        titleOfEntry: "",
        descriptionOfEntry:"",
        isBookmarked: false,
        selectedCategory: null,

        title: "Todo",
        active: false,
        todotitle: "",
        todosubtitle: "",
        bookmark: "",
        isChk: [],
        isActive: false,
        badgeactive: [],
        search: "",
        todos: [

        ],
        progresstodo: [

        ],
        completetodo: [

        ],
        onholdtodo: [
          {
            todotitle: "Meeting with Clients",
            todosubtitle:
                    "Blandit tempus porttitor aasfs. Integer posuere erat a ante venenatis.",
            badgeactive: true
          },
          {
            todotitle: "Go for walk in weekends",
            todosubtitle:
                    "Integer posuere erat a ante vene natis.Blandit tempus porttitor aasfs.",
            badgeactive: false
          },

        ]
      }
    },

  components: {
    draggable
  },
    async created(){
      let api = new KanbanApi();
      let result = await api.getKanbanEntries();
      this.kanbanList = result.data.items;
    },
  methods: {
    filtering:  _.debounce(async(e) => {
      e.preventDefaultAction = true;
      let api = new ClioMatterApi();
      let searchText = e.text;
      let result = await api.searchForMatters(searchText);
      //pass the filter data source, filter query to updateData method.
      e.updateData(result.data.data);
    },1000),
    activateSidebar: function(){
      this.active = true;
      this.isActive = true;
    },

    onMatterChanged: function(e){
      this.selectedMatter = e.itemData;
    },
    onCategoryChanged: function(e){
      this.selectedCategory = e.itemData;
    },
    async addTodo() {
      let entry = new CreateKanbanEntry();
      entry.badgeActive = this.isBookmarked;
      entry.clientId = this.selectedMatter.clientId;
      entry.clientName = this.selectedMatter.clientName;
      entry.matterId = this.selectedMatter.id;
      entry.matterName = this.selectedMatter.description;
      entry.title = this.titleOfEntry;
      entry.description = this.descriptionOfEntry;
      entry.category = this.selectedCategory.value;

      let api = new KanbanApi();
      let resultOfPost = await api.createKanbanEntry(entry);

      //unselected matter
      this.isBookmarked = false;
      this.titleOfEntry = "";
      this.descriptionOfEntry = "";
      //unselected categroy

      var data = resultOfPost.data;
      if (data.category==="Waiting"){
        this.waitingList.unshift(data);

      }
      else if(data.category==="To Do"){
        this.toDoList.unshift(data);
      }
      else if(data.category==="In Progress"){
        this.inProgressList.unshift(data);
      }
      else if(data.category==="Done"){
        this.doneList.unshift(data);
      }
      else if(data.category==="On Hold"){
        this.onHoldList.unshift(data);
      }
    },
    showBookmark() {
      this.isActive = !this.isActive;
    },
    submitForm(e) {
      const todo_bunch = {
        todotitle: this.todotitle,
        todosubtitle: this.todosubtitle,
        badgeactive: false
      };
      this.todos.unshift(todo_bunch);

      this.todotitle = "";
      this.todosubtitle = "";
      this.badgeactive = "";
      // To prevent the form from submitting
      e.preventDefault();
    }
  }
});
